import { useTranslation } from "react-i18next";
import { RouteStatusAction } from "./RouteStatusAction.js";
import { RouteStatusPage } from "./RouteStatusPage.js";

/** Unknown URL. Rendered for authenticated and unauthenticated visitors alike. */
export function NotFoundPage({ homePath }: { homePath: string }): React.JSX.Element {
  const { t } = useTranslation();

  return (
    <RouteStatusPage
      code="404"
      title={t("routeStatus.notFound.title")}
      description={t("routeStatus.notFound.description")}
      action={<RouteStatusAction to={homePath} label={t("routeStatus.notFound.action")} />}
    />
  );
}
